const empty = Object.freeze({ jobs: [], stopping: false });
export default function useProjectCommandState() { return empty; }
